meedy.controller('meedy.popupCertificateExpirationController', ['$scope', '$mdDialog', 'zusCertificateCopy', 'expirationDate',
    function ($scope, $mdDialog, zusCertificateCopy, expirationDate) {

        function setData() {
            $scope.zusCertificateCopy = zusCertificateCopy;
            $scope.expirationDate = expirationDate;
        }

        function setActions() {
            $scope.ok = function () {
                $mdDialog.hide();
            };
        }

        setData();
        setActions();
    }
]);
